import { useEffect, useRef, useState } from "react";

import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

/**
 * Matn filtri.
 *
 * Har bosishda so'rov yubormaydi: 500 ms jim turgandan keyin bir marta —
 * busiz "Nuriddinov" so'zi o'nta so'rov qilardi va oxirgisidan boshqasi
 * baribir tashlab yuborilardi.
 */
export function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange">) {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialValue);
  const [prevInitialValue, setPrevInitialValue] = useState(initialValue);
  const inputRef = useRef<HTMLInputElement>(null);

  // Tashqi qiymat o'zgarsa (masalan "Tozalash" bosilsa) ichkarisi ham
  // yangilanadi. Render paytida `setState` — React renderni darhol yangi holat
  // bilan qayta boshlaydi, qo'shimcha render bo'lmaydi.
  if (prevInitialValue !== initialValue) {
    setPrevInitialValue(initialValue);
    setValue(initialValue);
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, onChange, debounce]);

  // Filtr oynasi ochilishining yagona sababi — yozish.
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className="relative">
      <Input
        ref={inputRef}
        {...props}
        value={value}
        onChange={e => setValue(e.target.value)}
        className="w-64 border-none pe-9 shadow-none focus-visible:ring-[1px]"
      />
      {value ? (
        <Button
          type="button"
          size="icon"
          variant="ghost"
          className="bg-accent absolute top-1 right-1 z-10 size-7"
          aria-label={t("TABLE.CLEAR")}
          onClick={() => setValue("")}
        >
          <X />
        </Button>
      ) : null}
    </div>
  );
}
